export default (page, list, countPage) => {
  if (countPage === 1) return list;
  const countOfElementOnPage = 5;
  const start = (page - 1) * countOfElementOnPage;
  const end = start + countOfElementOnPage;
  return list.slice(start, end);
};
